import dayjs from 'dayjs';
import flatpickr from "flatpickr";
const Portuguese = require("flatpickr/dist/l10n/pt.js").default.pt;
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect';

function getMinDate(self) {
     
    return self.data('min-date') === 'today' 
        ? "today" : 
        !self.data('min-date') 
        ? '' :
        new Date(self.data('min-date'))
}

$(".datepicker").flatpickr({
    locale: Portuguese,
    allowInput: true,
    altInputClass: "date form-control",
    altInput: true,
    altFormat: "d/m/Y",
    dateFormat: "Y-m-d",
    disableMobile: true
});

$(".datetimepicker").flatpickr({
    locale: Portuguese,
    enableTime: true,
    allowInput: true,
    altInputClass: "datetime form-control",
    altInput: true,
    altFormat: "d/m/Y H:i",
    dateFormat: "Y-m-d H:i",
    disableMobile: true,
});

$(".timepicker").flatpickr({
    locale: Portuguese,
    allowInput: true,
    altInputClass: "time form-control",
    altInput: true,
    enableTime: true,
    noCalendar: true,
    dateFormat: "H:i",
    altFormat: "H:i",
    time_24hr: true,
    disableMobile: true
});


$(".rangedatepicker").flatpickr({
    locale: Portuguese,
    mode: "range",
    allowInput: true,
    altInputClass: "date form-control",
    altInput: true,
    altFormat: "d/m/Y",
    dateFormat: "Y-m-d",
    disableMobile: true,
    onChange: function(selectedDates, dateStr, instance) {
        instance.element.value = selectedDates.map(r => r.toJSON());
    },
});


$(".monthpicker").flatpickr({
    locale: Portuguese,
    altInput: true,
    allowInput: true,
    altInputClass: "date form-control",
    plugins: [
        new monthSelectPlugin({
          shorthand: false, //defaults to false
          dateFormat: "Y-m", //defaults to "F Y"
          altFormat: "F/Y", //defaults to "F Y"
          altInput: true,
        })
    ]
});


function bookingDatePicker() {
    const bookingAreaSelect = $('select[name="booking_area_id"]');
    const bookingDateSelect = $('select[name="booking_date"]');
    const bookingTimeSelect = $('select[name="booking_slot_id"]');

    const bootstrapInput = async (option) => {
        if (option) {   
            
            bookingDateSelect.find('option').not(':first').remove().trigger("change");

            bookingDateSelect.data('data-booking-area-id', "");

            if (option.value) {


                const {data: options} = await axios.post('/admin/booking/slot/get-date-slots-by-area', {
                    booking_area_id: option.value
                });
                
                if (bookingDateSelect) {
                    bookingDateSelect.data('data-booking-area-id', option.value);

                    const currentDateSelect = bookingDateSelect.data('data-booking-date');
                    for await (const opt of options) {
                        const date = dayjs(opt.booking_date);
                        const newOption = new Option(date.format('DD/MM/YYYY'), date.format('YYYY-MM-DD'), currentDateSelect == date.format('YYYY-MM-DD'), currentDateSelect == date.format('YYYY-MM-DD'));
                        bookingDateSelect.append(newOption);
                    }
                }
            }
            

            bookingDateSelect.trigger('change');
        }
    }


    const bootstrapDateInput = async (option) => {
        if (option) {   
            
            bookingTimeSelect.find('option').not(':first').remove().trigger("change");
            const currentAreaId = bookingDateSelect.data('data-booking-area-id');

            if (option.value) {
                const {data: options} = await axios.post('/admin/booking/slot/get-time-slots-by-area', {
                    booking_date: option.value,
                    booking_area_id: parseInt(currentAreaId)
                });
                
                if (bookingTimeSelect) {
                    const currentSlotSelect = bookingTimeSelect.data('data-booking-slot-id');
                    for await (const opt of options) {
                        const newOption = new Option(opt.option_time, opt.id, currentSlotSelect == opt.id, currentSlotSelect == opt.id);
                        bookingTimeSelect.append(newOption);
                    }


                }
            }
            

            bookingTimeSelect.trigger('change');
        }
    }


    if (bookingAreaSelect) {
        bookingAreaSelect.on("select2:select", async (evt) => {
            const element = evt.target;
            const option = element.options[element.selectedIndex];

            // console.log('option: ', option);

            bookingDateSelect.prop('disabled', false);
            // bookingTimeSelect.prop('disabled', false);
            await bootstrapInput(option);
        });
    
        bookingAreaSelect.on("select2:clear", async (evt) => {
            const element = evt.target;
            const option = element.options[element.selectedIndex];

            // console.log('option: ', option);

            bookingDateSelect.prop('disabled', true); 
            bookingTimeSelect.prop('disabled', true);
            await bootstrapInput(option);
        });



        bookingDateSelect.on("select2:select", async (evt) => {
            const element = evt.target;
            const option = element.options[element.selectedIndex];

            bookingTimeSelect.prop('disabled', false);
            await bootstrapDateInput(option);
        });
    
        bookingDateSelect.on("select2:clear", async (evt) => {
            const element = evt.target;
            const option = element.options[element.selectedIndex];

            // bookingDateSelect.prop('disabled', true); 
            bookingTimeSelect.prop('disabled', true);
            // await bootstrapDateInput(option);
        });
    }
}


bookingDatePicker();